import { uuid } from 'vue-uuid';

const GENERATED_STR = '__generated';
const IS_NEW_STR = 'new__';

export function generateId(isNew) {
  // accepts 'isNew' variable to create unique ID that can be recognized as 'new'
  return `${isNew ? IS_NEW_STR : ''}${uuid.v4()}${GENERATED_STR}`;
}

export function isIdGenerated(id) {
  if (!id) {
    console.error(new Error('isIdGenerated was called without any value'));
    return false;
  }
  return id.substring(id.length - GENERATED_STR.length) === GENERATED_STR;
}

export function isIdNew(id) {
  if (!id) { throw new Error('isIdNew was called without any value'); }
  return id.substring(0, IS_NEW_STR.length) === IS_NEW_STR;
}
